import {  Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import SimpleCard from "../../../Common/SimpleCard";
import { useState, useEffect } from "react";
import axios from "../../../utils/http";
import { APP_LIST_COMP } from "../../../utils/urls";
import { useHistory } from "react-router";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        boxRoot: {
            "@media (min-width: 1280px)": {
                height: "100vh",
                padding: "20px",
            },
            [theme.breakpoints.down("xs")]: {
                height: "100vh",
                padding: "20px",
            },
            [theme.breakpoints.between("sm", "md")]: {
                height: "100vh",
                padding: "20px",
            },
        },
        root: {
            flexGrow: 1,
            padding: "10px",
        },
    })
);

export default function Complete() {
    const history = useHistory();

    const [data, setData] = useState<any>([]);
    const [loader, setLoader] = useState(true);

    const classes = useStyles();

    useEffect(function () {
        axios
            .get(APP_LIST_COMP)
            .then((response) => {
                setData(response.data.results);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setLoader(false);
            });
    }, []);

    return loader ? (
        <Loader loading={true} />
    ) : (
        <Box sx={{ mt: 7 }}>
            <div>
                <Header pageName="Applications Completed" />
            </div>

            <Grid container direction="column">
                <Box className={classes.boxRoot}>
                    <Grid container className="statusGrid">
                        {data.length > 0 ? (
                            data.map((item: any, index: number) => {
                                return (
                                    <Grid
                                        item
                                        xs={12}
                                        key={index}
                                        onClick={() => history.push(item["Landing Page"])}
                                    >
                                        <SimpleCard
                                            heading="Complete"
                                            username={item.Username}
                                            userID={item["User ID"]}
                                            productName={item["Product Name"]}
                                            color="#70A461"
                                        />
                                    </Grid>
                                );
                            })
                        ) : (
                            <p>No Detail found.</p>
                        )}
                    </Grid>

                    <Grid container justifyContent="center" spacing={1}>
                        {/* <Grid item className="header" style={{width:"345px",marginTop:"30px"}}>
        </Grid> */}
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Box className={classes.boxRoot}></Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Box>
    );
}
